import { useNavigate } from 'react-router-dom';
import { SupplierAttributeType } from '@prisma/client';
import { Alert, Button, Card, Form, Input, Radio, Result, Space } from 'antd';
import { isAxiosError } from 'axios';

import { SupplierPicker } from '../../../../common';
import { useCreateSupplierAttribute } from '../data';

type SupplierData = {
  supplierId?: string | null;
  supplierName?: string | null;
};

export const CreateForm = ({ supplierId, supplierName = '' }: SupplierData) => {
  const create = useCreateSupplierAttribute();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  if (create.isSuccess) {
    return (
      <Result
        status="success"
        title="Successfully created a Supplier Attribute"
        extra={[
          <Button type="primary" key="go to Supplier Attribute Mapping" onClick={() => navigate('../')}>
            Go To Supplier Attribute Mapping
          </Button>,
          <Button
            key="create another"
            onClick={() => {
              create.reset();
              form.resetFields();
            }}
          >
            Create Another
          </Button>,
        ]}
      />
    );
  }

  return (
    <Space size="large" style={{ width: '100%' }} wrap>
      <Form
        disabled={create.isPending || create.isSuccess}
        form={form}
        initialValues={supplierId ? { supplier: { label: supplierName, value: supplierId.toString() } } : undefined}
        labelCol={{ span: 4 }}
        layout="vertical"
        style={{ width: '100%', minWidth: 1000 }}
        onFinish={({ supplier, attribute, attributeType }) =>
          create.mutate({ externalSupplierId: parseInt(supplier.value), attribute, attributeType })
        }
      >
        {create.error ? (
          <Form.Item label=" " colon={false} hidden={!create.error}>
            <Alert
              message="Error"
              description={isAxiosError(create.error) ? create?.error.response?.data['message'] : create.error}
              type="error"
              showIcon
            />
          </Form.Item>
        ) : undefined}
        <Card>
          <Form.Item label="Supplier" name="supplier" rules={[{ required: true, message: `Supplier is required` }]}>
            <SupplierPicker.Select placeholder="Supplier to map attribute to" />
          </Form.Item>
          <Form.Item
            label="Attribute Type"
            name="attributeType"
            rules={[{ required: true, message: 'Attribute type is required.' }]}
          >
            <Radio.Group buttonStyle="solid">
              <Radio.Button value={SupplierAttributeType.DMS_NAME}>DMS</Radio.Button>
              <Radio.Button value={SupplierAttributeType.T3_NAME}>T3</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Attribute Name"
            name="attribute"
            style={{ paddingBottom: 12 }}
            hasFeedback
            rules={[
              { required: true, message: 'Attribute name is required.' },
              // { pattern: new RegExp(/^([A-Za-z0-9_-]+)$/), message: 'Invalid attribute name' },
            ]}
          >
            <Input />
          </Form.Item>
          <Space style={{ marginTop: 20 }}>
            <Button type="primary" htmlType="submit" loading={create.isPending}>
              Save
            </Button>
            <Button onClick={() => form.resetFields()}>Reset</Button>
            <Button onClick={() => navigate('../')}>Cancel</Button>
          </Space>
        </Card>
      </Form>
    </Space>
  );
};
